import itiriri from 'itiriri';
import React, {useState} from 'react';
import styled from 'styled-components';
import { CsvParser } from '../../../../components/CsvParser';
import { ValidationMessages } from '../../../../core/utils/validationMessages';
import { createDataSource, DataTable } from '../../../../kit/DataTable/DataTable';
import { Layout } from '../../../../kit/Layout';
import { OnboardingPageActions } from '../OnboardingPage';
import { NextButton, PageNavigationButtonContainer, PreviousButton } from './NavigationButtonContainer';
import { Text } from '../../../../kit/Text';
import { apis } from '../../../../core/mrs/apis';
import { useAsync } from '../../../../kit/hooks/UseAsync';
import {
    RoleDto,
    LoginType,
    UserOnboardingReq,
    FacilityRoleDto,
    OidcProviderType,
    OidcProviderDto
} from "server-openapi";
import {ImportUsersDialogContent} from "../../FacilitySettings/components/Users/ImportUsersDialogContent";
import {ImportUsersDetail} from "../../FacilitySettings/components/Users/ImportUsersDetail";
import {Button, Variation} from "../../../../kit/Button";
import {Intent} from "../../../../kit/Theme/Theme";
import {Dialog} from "../../../../kit/Dialog";

interface IProps extends OnboardingPageActions {
  selectedFacilityGroupId: number;
  oidcProviders: OidcProviderDto[];
}

export function InviteFacilityUsersPanel(props: IProps) {
  const [importUsers, setImportUsers] = useState<UserOnboardingReq[]>([]);
  const [openImportUsersDialog, setOpenImportUsersDialog] = useState(false);

  const [useUserPermissionsFromHs, setUseUserPermissionsFromHs] = useState<boolean>(false);
  const [roles, setRoles] = useState<RoleDto[]>([]);
  const [facilityRoles, setFacilityRoles] = useState<FacilityRoleDto[]>([]);

  useAsync(async () => {
      const usePermsFromHs =
          (await apis.GlobalSettingsApi.globalSettingsUseUserPermissionsFromHs(props.selectedFacilityGroupId)).data;

      setUseUserPermissionsFromHs(usePermsFromHs ?? false);

      if (usePermsFromHs) {
          setFacilityRoles((await apis.facilityRoles.facilityRoleGetFacilityRolesForUser(props.selectedFacilityGroupId)).data);
      } else {
          setRoles((await apis.roles.roleGetAll(props.selectedFacilityGroupId)).data);
      }
  }, [props.selectedFacilityGroupId]);

function usersSelected(usersToImport: UserOnboardingReq[]) {
    setImportUsers(usersToImport);
    setOpenImportUsersDialog(false);
}
  function updateCompleted() {
        setImportUsers([]);
  }

  return (
    <>
        <Dialog
            lazy
            open={openImportUsersDialog}
            onRequestClose={() => setOpenImportUsersDialog(false)}
            size="sm"
            secondary
        >

        <ImportUsersDialogContent
            facilityGroupId={props.selectedFacilityGroupId}
            roles={roles}
            facilityRoles={facilityRoles}
            useUserPermissionsFromHs={useUserPermissionsFromHs}
            usersSelected={usersSelected} />
        </Dialog>
        {
            (importUsers.length > 0) ?
                <ImportUsersDetail
                    usersToImport={importUsers}
                    facilityGroupId={props.selectedFacilityGroupId}
                    roles={roles}
                    facilityRoles={facilityRoles}
                    useUserPermissionsFromHs={useUserPermissionsFromHs}
                    allowedIdpProviders={props.oidcProviders}
                    updateCompleted={updateCompleted}></ImportUsersDetail>
                :
                <Layout horizontal gap={1} justify="right">
                    <Button onClick={() => setOpenImportUsersDialog(true)} intent={Intent.Secondary} variation={Variation.outline}>
                        IMPORT CSV
                    </Button>
                </Layout>

        }
    </>
  );

}

const ButtonActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;
